import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"close\"><path d=\"M28.924.339l-12.917 13.1L3.076.375a1.17 1.17 0 0 0-1.647 0l-1.09.916a1.169 1.169 0 0 0 0 1.646l13.066 13.025L.339 28.913a1.169 1.169 0 0 0 0 1.646l1.09 1.102a1.17 1.17 0 0 0 1.647 0l12.917-13.062 12.931 13.062a1.17 1.17 0 0 0 1.647 0l1.09-1.102a1.169 1.169 0 0 0 0-1.646L18.595 16 31.661 3.087a1.169 1.169 0 0 0 0-1.646L30.571.339a1.17 1.17 0 0 0-1.647 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol